import { Box, Typography } from "@mui/material";
import { Roadblock } from "./roadblock";

export const ErrorPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        pt: 8,
      }}
    >
      <Typography sx={{ mb: 10, p: 5 }}>
        Something went wrong. Try opening the original link again.
      </Typography>
      <Box
        sx={{
          maxHeight: "250px",
          maxWidth: "250px",
          height: "50%",
          width: "50%",
        }}
      >
        <Roadblock />
      </Box>
    </Box>
  );
};
